import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import { HeaderFetcher } from '@sainsburys-tech/bolt'
import { getSearchPath } from '@sainsburys-tech/boltui-utils'

import { withRouter } from 'react-router-dom'
import TaggingSerializer from '../../helpers/TaggingSerializer'
import CookieTracking from '../../utils/CookieTracking'
import HeadHelper from '../../helpers/HeadHelper'
import CanonicalHelper from '../../helpers/CanonicalHelper'
import { BrowseHelper } from '../../helpers/BrowseHelper'
import { isSearchOrCannedOrSd } from '../../helpers/RoutingHelper'

class Header extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      userInfo: {
        trolleyCount: 0
      }
    }

    this.onUserInfoLoad = this.onUserInfoLoad.bind(this)
    this.updateDigitalDataObject = this.updateDigitalDataObject.bind(this)
    this.getSearchTerm = this.getSearchTerm.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loader.show && !this.props.loader.show) {
      this.updateDigitalDataObject()
    }
  }

  onUserInfoLoad(userInfo) {
    this.setState({ userInfo })
    this.updateDigitalDataObject()
    return {}
  }

  getSearchTerm() {
    if (
      (this.props.brandSuggestions && this.props.brandSuggestions.length > 0) ||
      this.props.spellcheckedSearch ||
      this.props.productStore.isCannedSearch ||
      this.props.applicationStore.pageType === 'canned'
    ) {
      return ''
    }
    if (this.props.inputSearchTerm) return this.props.inputSearchTerm
    return this.props.searchTerm || ''
  }

  setRenderNoIndexTag() {
    const appStore = this.props.applicationStore
    const { categoryStore, productStore } = this.props
    const { isCategoryLive } = categoryStore
    const { pageType } = appStore
    const isCanned = productStore.isCannedSearch
    if (isSearchOrCannedOrSd(pageType)) {
      return isCanned || appStore.searchNoIndex
    }
    if (pageType === 'browse') {
      return BrowseHelper.isNoIndex(appStore.seoRobotMeta, appStore.appliedFilters) && isCategoryLive
    }
    return false
  }

  setMetaTags() {
    const renderNoIndexTag = this.setRenderNoIndexTag()
    const metaTags = [{ name: 'description', content: this.props.description }]
    if (renderNoIndexTag) {
      metaTags.push({ name: 'robots', content: 'NOINDEX' })
    }

    return metaTags
  }

  updateDigitalDataObject() {
    const productStoreState = this.props.productStore
    // channel is set using a cookie in <head>
    const { channel } = window.digitalData.page.attributes

    const autoSuggestCookie = CookieTracking.getTrackingEvent('autosuggest')
    // if there is no cookie maintain the previous cookie value
    this.autoSuggestCookie = autoSuggestCookie || this.autoSuggestCookie

    const taggingSerializer = new TaggingSerializer(
      productStoreState,
      this.props.categoryStore,
      this.props.applicationStore,
      { channel, autoSuggestCookie: this.autoSuggestCookie },
      this.state.userInfo
    )
    Object.assign(window.digitalData, taggingSerializer.getDataObject())
    const trackingEvent = taggingSerializer.getSatelliteTrackingEvent()
    if (trackingEvent) {
      this.fireSatelliteTrackingEvent(trackingEvent)
    }
  }

  fireSatelliteTrackingEvent(eventName) {
    if (eventName && typeof window.digitalData !== 'undefined' && !!window.digitalData.track) {
      window.digitalData.track(eventName)
    }
  }

  render() {
    const productStoreState = this.props.productStore
    const { categoryStore } = this.props
    const { applicationStore } = this.props
    const { canonical } = new CanonicalHelper(categoryStore, productStoreState, applicationStore)
    const metaTags = this.setMetaTags()
    const linkTags = HeadHelper.getLinkTags(canonical, productStoreState, categoryStore)

    const handleSearch = (searchTerm, trackingParams, evt) => {
      if (evt) evt.preventDefault()
      document.activeElement.blur()
      this.context.navigateTo(getSearchPath(searchTerm) + trackingParams)

      return Promise.resolve()
    }

    return (
      <div>
        <Helmet title={this.props.pageTitle} link={linkTags} meta={metaTags} />
        <HeaderFetcher.ArgosHeader
          catalogId={10001}
          config='default'
          onSearchSubmit={handleSearch}
          overrideOnSearchSubmit={handleSearch}
          onUserInfoLoad={this.onUserInfoLoad}
          searchTerm={this.getSearchTerm()}
          overrideSearchTerm={this.getSearchTerm()}
          style={{ zIndex: 1, position: 'relative' }}
          overrideTrolleyCount={this.props.trolleyCount + this.state.userInfo.trolleyCount}
          overrideWishlistCount={this.props.wishlistCount}
          skipToContentTag='#findability'
        />
      </div>
    )
  }
}

Header.propTypes = {
  searchTerm: PropTypes.string,
  pageTitle: PropTypes.string,
  loader: PropTypes.object,
  categoryStore: PropTypes.object,
  applicationStore: PropTypes.object,
  spellcheckedSearch: PropTypes.bool,
  inputSearchTerm: PropTypes.string,
  productStore: PropTypes.object,
  brandSuggestions: PropTypes.array,
  description: PropTypes.string,
  trolleyCount: PropTypes.number,
  wishlistCount: PropTypes.number
}

Header.contextTypes = {
  navigateTo: PropTypes.func,
  store: PropTypes.object
}

Header.defaultProps = {
  searchTerm: '',
  pageTitle: '',
  loader: {},
  categoryStore: {},
  applicationStore: {},
  spellcheckedSearch: false,
  inputSearchTerm: '',
  productStore: {},
  brandSuggestions: [],
  description: '',
  trolleyCount: null,
  wishlistCount: null
}

export default withRouter(Header)
